module.exports = __webpack_public_path__ + "img/1535048207.c34705b9.jpg";